import { jsx as o } from "react/jsx-runtime";
import { I as t } from "../icon-DNHpBTHs.mjs";
const l = {
  name: "arrow-right",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M20.9 12a.9.9 0 0 1-.264.636l-5.5 5.5a.9.9 0 0 1-1.272-1.272l3.963-3.964H4a.9.9 0 0 1 0-1.8h13.827l-3.963-3.964a.9.9 0 1 1 1.272-1.272l5.5 5.5A.9.9 0 0 1 20.9 12Z" clip-rule="evenodd"/></svg>',
  keywords: ["arrow-right"],
  category: "utility"
}, i = (r) => /* @__PURE__ */ o(t, { ...r, svg: l });
i.displayName = "IconArrowRight";
export {
  i as IconArrowRight
};
//# sourceMappingURL=arrow-right.es.js.map
